import { Helmet } from "react-helmet";
import LoanHero from "../home/LoanHero";
import LoanWhyChoose from "../home/LoanWhyChoose";
import LoanOptions from "../home/LoanOptions";
import LoanProcess from "../home/LoanProcess";
import LoanBenefits from "../home/LoanBenefits";
import LoanEligibility from "../home/LoanEligibility";
import LoanDocuments from "../home/LoanDocuments";
import LoanFinalCta from "../home/LoanFinalCta";

export default function Loan() {
  return (
    <>
      <Helmet>
        <title>GPS Finvest - Loans</title>
        <meta
          name="description"
          content="Get the right loan for your needs at competitive rates with quick approval and minimal documentation from GPS Finvest."
        />
      </Helmet>

      <LoanHero />
      <LoanWhyChoose />
      <LoanOptions />
      <LoanProcess />
      <LoanBenefits />
      <LoanEligibility />
      <LoanDocuments />
      <LoanFinalCta />
    </>
  );
}
